module.exports = __webpack_public_path__ + "img/Weapon_298.fc00427a.png";